import API from "../Api";

export const apiBenefits = () => API.patch(`/api/v1/user/benefitsummary`);